"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ControlProperties = /** @class */ (function () {
    function ControlProperties() {
        this.categorySystemName = 'N/A';
        this.formSystemName = 'N/A';
        this.cardTitle = 'N/A';
        this.tabName = 'N/A';
        this.title = 'N/A';
        this.hint = 'N/A';
        this.maxLength = 'N/A';
        this.notes = 'N/A';
        this.tooltipCaption = 'N/A';
        this.tooltipContent = 'N/A';
        this.compoundCategoryDisplayName = 'N/A';
        this.compoundCategoryDbTableName = 'N/A';
        this.dbTableName = 'N/A';
        this.dbColumnName = 'N/A';
        this.conditional = 'NO';
    }
    return ControlProperties;
}());
exports.ControlProperties = ControlProperties;
//# sourceMappingURL=control-properties.js.map